import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {AlertService, PlanService} from "../_services";
import {PlanListAbstractComponent} from "./plan-list-abstract.component";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.css']
})
export class PlanComponent extends PlanListAbstractComponent {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected planService: PlanService,
    protected alertService: AlertService,
  ) {
    super(router, location, route, planService, alertService);
    this.objectName = 'plan';
    this.title = 'Billing Plans';
  }
}
